// MIT © 2017 azu
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * AST Node types list on TxtNode.
 * @see https://github.com/textlint/textlint/blob/master/docs/txtnode.md
 */
exports.ASTNodeTypes = {
    Document: "Document",
    Paragraph: "Paragraph",
    BlockQuote: "BlockQuote",
    ListItem: "ListItem",
    List: "List",
    Header: "Header",
    CodeBlock: "CodeBlock",
    HtmlBlock: "HtmlBlock",
    ReferenceDef: "ReferenceDef",
    HorizontalRule: "HorizontalRule",
    Comment: "Comment",
    // inline
    Str: "Str",
    Break: "Break",
    Emphasis: "Emphasis",
    Strong: "Strong",
    Html: "Html",
    Link: "Link",
    Image: "Image",
    Code: "Code",
    Delete: "Delete"
};
//# sourceMappingURL=TextLintASTNodeTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@textlint/ast-node-types/lib/TextLintASTNodeTypes.js
// module id = 154
// module chunks = 0